import React, {Fragment} from 'react';
import loadable from '@loadable/component';

import {
    CACHE as LOADING_CACHE,
    placeholderFromType,
} from '../../common/loading';

const AsyncExploreBookEnjoyLoadable = loadable(
    () =>
        import(
            /* webpackChunkName: "explore-book-enjoy" */
            /* webpackPrefetch: true */
            './ExploreBookEnjoy'
        ),
    {ssr: false}
);

export const AsyncExploreBookEnjoy = () => {
    const componentPlaceholder = placeholderFromType(AsyncExploreBookEnjoy); // eslint-disable-line no-use-before-define

    const element = (
        <AsyncExploreBookEnjoyLoadable
            fallback={<Fragment>{componentPlaceholder}</Fragment>}
        />
    );

    return element;
};

AsyncExploreBookEnjoy.displayName = 'AsyncExploreBookEnjoy';

LOADING_CACHE.set(AsyncExploreBookEnjoy, {
    blockCount: 3,
    componentType: 'AsyncExploreBookEnjoy',
    placeholderType: 'HBlocks',
    size: 'sm',
});
